/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Flavors_FoundInputs */

const en_no_flavors_found = /** @type {(inputs: No_Flavors_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No flavors found.`)
};

const es_no_flavors_found = /** @type {(inputs: No_Flavors_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron sabores.`)
};

/**
* | output |
* | --- |
* | "No flavors found." |
*
* @param {No_Flavors_FoundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const no_flavors_found = /** @type {((inputs?: No_Flavors_FoundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Flavors_FoundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_flavors_found(inputs)
	return es_no_flavors_found(inputs)
});